import { render, staticRenderFns } from "./FilterList1new.vue?vue&type=template&id=32f9c70c&scoped=true&"
import script from "./FilterList1new.vue?vue&type=script&lang=js&"
export * from "./FilterList1new.vue?vue&type=script&lang=js&"
import style0 from "./FilterList1new.vue?vue&type=style&index=0&id=32f9c70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9c70c",
  null
  
)

export default component.exports